import { IFullfilledMonthsResponse } from "../../services/Standard-of-care/standard-of-care.interface";
import MonthCarousel from "../MonthCarousel/MonthCarousel";
import React from "react";

interface IPreventativeMonthCarousal{
  fulfilledMonths: IFullfilledMonthsResponse[];
  handleSocDataSelect: (data: IFullfilledMonthsResponse) => void;
  eventName: string;
}

const PreventativeMonthCarousal = ({ fulfilledMonths, handleSocDataSelect, eventName }: IPreventativeMonthCarousal) => {
  return (
    <>
      <div className="font-medium text-sm ms-[1.2rem]">
        {`${eventName} is a monthly requirement and is self-reported`}
      </div>
      <div className="mx-[1.2rem] !relative">
        <MonthCarousel data={fulfilledMonths} handleSocDataSelect={handleSocDataSelect} />
      </div>
    </>
  );
};

export default PreventativeMonthCarousal;
